const initialDocumentsFilterState = {
  apps               : [],
  appRefs            : [],
  year               : [],
  appType            : [],
};

export const statisticsFilterReducer = (state = initialDocumentsFilterState, action) => {
  switch (action.type) {

    case "SET_STATS_APPLICATIONS_FILTER": {
      return {...state, apps: action.payload};
    }

    case "SET_STATS_EVENTS_FILTER": {
      return {...state, appRefs: action.payload};
    }

    case "SET_STATISTIC_APP_TYPE_FILTER": {
      return {...state, appType: action.payload};
    }

    case "SET_STATS_YEAR_FILTER": {
      return {...state, year: action.payload};
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/filters/statisticsFilter.js